export const GET_USER_NAME_SUCCESS = "GET_USER_NAME_SUCCESS";
export const GET_USER_NAME_FAILURE = "GET_USER_NAME_FAILURE";

export const UPDATE_SETTING_SUCCESS = "UPDATE_SETTING_SUCCESS";
export const UPDATE_SETTING_FAILURE = "UPDATE_SETTING_FAILURE";

export const USER_CHAMBER_NAME_SUCCESS = "USER_CHAMBER_NAME_SUCCESS";
export const USER_CHAMBER_NAME_FAILURE = "USER_CHAMBER_NAME_FAILURE";
